module.exports = __webpack_public_path__ + "img/Menu-icon.c545cad4.svg";